export default "__VITE_ASSET__soMCCZ____"